module.exports = __webpack_public_path__ + "static/media/schedules.5de7a4a0.svg";